;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="651528ba-43b7-45c3-8a69-f14e6df5e8ca",e._sentryDebugIdIdentifier="sentry-dbid-651528ba-43b7-45c3-8a69-f14e6df5e8ca")}catch(e){}}();
"use strict";
(self["webpackChunkretino"] = self["webpackChunkretino"] || []).push([[716],{

/***/ 15110:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export ReactComponent */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPoweredByStripeBlurple = function SvgPoweredByStripeBlurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Powered_by_Stripe-blurple_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 150 34"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Powered_by_Stripe-blurple_svg__cls-1{fill:#635bff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146 0H3.73A3.73 3.73 0 0 0 0 3.73v26.54A3.73 3.73 0 0 0 3.73 34H146a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4m3 30a3 3 0 0 1-3 3H3.73A2.74 2.74 0 0 1 1 30.27V3.73A2.74 2.74 0 0 1 3.73 1H146a3 3 0 0 1 3 3Z",
    className: "Powered_by_Stripe-blurple_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.07 11.24h-4.3V22h1.92v-4.16h2.38c2.4 0 3.9-1.16 3.9-3.3s-1.5-3.3-3.9-3.3m-.1 5h-2.28v-3.3H17c1.38 0 2.11.59 2.11 1.65s-.76 1.6-2.11 1.6ZM25.1 14a3.77 3.77 0 0 0-3.8 4.09 3.81 3.81 0 1 0 7.59 0A3.76 3.76 0 0 0 25.1 14m0 6.67c-1.22 0-2-1-2-2.58s.76-2.58 2-2.58 2 1 2 2.58-.79 2.57-2 2.57ZM36.78 19.35l-1.41-5.22h-1.48l-1.4 5.22-1.42-5.22h-1.85l2.37 7.88h1.56l1.44-5.16 1.44 5.16h1.56l2.37-7.88h-1.78zM44 14a3.83 3.83 0 0 0-3.75 4.09 3.79 3.79 0 0 0 3.83 4.09A3.47 3.47 0 0 0 47.49 20L46 19.38a1.78 1.78 0 0 1-1.83 1.26A2.12 2.12 0 0 1 42 18.47h5.52v-.6C47.54 15.71 46.32 14 44 14m-1.93 3.13A1.92 1.92 0 0 1 44 15.5a1.56 1.56 0 0 1 1.69 1.62ZM50.69 15.3v-1.17h-1.8V22h1.8v-4.13a1.89 1.89 0 0 1 2-2 5 5 0 0 1 .66 0v-1.8h-.51a2.29 2.29 0 0 0-2.15 1.23M57.48 14a3.83 3.83 0 0 0-3.75 4.09 3.79 3.79 0 0 0 3.83 4.09A3.47 3.47 0 0 0 60.93 20l-1.54-.59a1.78 1.78 0 0 1-1.83 1.26 2.12 2.12 0 0 1-2.1-2.17H61v-.6c0-2.19-1.24-3.9-3.52-3.9m-1.93 3.13a1.92 1.92 0 0 1 1.92-1.62 1.56 1.56 0 0 1 1.69 1.62ZM67.56 15a2.85 2.85 0 0 0-2.26-1c-2.21 0-3.47 1.85-3.47 4.09s1.26 4.09 3.47 4.09a2.82 2.82 0 0 0 2.26-1V22h1.8V11.24h-1.8Zm0 3.35a2 2 0 0 1-2 2.28c-1.31 0-2-1-2-2.52s.7-2.52 2-2.52c1.11 0 2 .81 2 2.29ZM79.31 14A2.88 2.88 0 0 0 77 15v-3.76h-1.8V22H77v-.83a2.86 2.86 0 0 0 2.27 1c2.2 0 3.46-1.86 3.46-4.09S81.51 14 79.31 14M79 20.6a2 2 0 0 1-2-2.28v-.47c0-1.48.84-2.29 2-2.29 1.3 0 2 1 2 2.52s-.75 2.52-2 2.52M86.93 19.66 85 14.13h-1.9l2.9 7.59-.3.74a1 1 0 0 1-1.14.79 4 4 0 0 1-.6 0v1.51a4.6 4.6 0 0 0 .73.05 2.67 2.67 0 0 0 2.78-2l3.24-8.62h-1.89ZM125 12.43a3 3 0 0 0-2.13.87l-.14-.69h-2.39v12.92l2.72-.59v-3.13a3 3 0 0 0 1.93.7c1.94 0 3.72-1.59 3.72-5.11 0-3.22-1.8-4.97-3.71-4.97m-.65 7.63a1.61 1.61 0 0 1-1.28-.52v-4.11a1.64 1.64 0 0 1 1.3-.55c1 0 1.68 1.13 1.68 2.58s-.69 2.6-1.7 2.6M133.73 12.43c-2.62 0-4.21 2.26-4.21 5.11 0 3.37 1.88 5.08 4.56 5.08a6.1 6.1 0 0 0 3-.73v-2.25a5.8 5.8 0 0 1-2.7.62c-1.08 0-2-.39-2.14-1.7h5.38v-1c.09-2.87-1.27-5.13-3.89-5.13m-1.47 4.07c0-1.26.77-1.79 1.45-1.79s1.4.53 1.4 1.79ZM113 13.36l-.17-.82h-2.32v9.71h2.68v-6.58a1.87 1.87 0 0 1 2.05-.58v-2.55a1.8 1.8 0 0 0-2.24.82M99.46 15.46c0-.44.36-.61.93-.61a5.9 5.9 0 0 1 2.7.72v-2.63a7 7 0 0 0-2.7-.51c-2.21 0-3.68 1.18-3.68 3.16 0 3.1 4.14 2.6 4.14 3.93 0 .52-.44.69-1 .69a6.8 6.8 0 0 1-3-.9V22a7.4 7.4 0 0 0 3 .64c2.26 0 3.82-1.15 3.82-3.16-.05-3.36-4.21-2.76-4.21-4.02M107.28 10.24l-2.65.58v8.93a2.77 2.77 0 0 0 2.82 2.87 4.16 4.16 0 0 0 1.91-.37V20c-.35.15-2.06.66-2.06-1v-4h2.06v-2.34h-2.06ZM116.25 11.7l2.73-.57V8.97l-2.73.57zM116.25 12.61h2.73v9.64h-2.73z",
    className: "Powered_by_Stripe-blurple_svg__cls-1"
  })));
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("https://cdn.retino.com/dist/files/react/img/billing/Powered_by_Stripe-blurple.svg");

/***/ }),

/***/ 48972:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ calendar_Calendar)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
;// ./react/components/calendar/DaySelect.tsx
/* provided dependency */ var moment = __webpack_require__(95093);

class DaySelect extends react.Component {
  constructor(props) {
    super(props);
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth();
    this.date = new Date().getDate();
    this.today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
  }
  handleOnSelect(day) {
    this.props.onChange(this.props.year, this.props.month, day);
  }
  render() {
    let day;
    let d;
    let current;
    let isDate;
    let className;
    const selectedDate = (this.props.value ? moment(this.props.value) : moment()).startOf('day').toDate();
    const weekStack = Array(7).fill(0).map(Number.call, Number);
    const startDay = this.props.firstOfMonth.getUTCDay() + 1;
    const first = this.props.firstOfMonth.getDay();
    const rows = Math.ceil((this.props.daysInMonth + startDay) / 7);
    className = rows === 6 ? 'r-dates' : 'r-dates r-fix';
    const haystack = Array(rows).fill(0).map(Number.call, Number);
    day = 1 - first;
    while (day > 1) {
      day -= 7;
    }
    day -= 1;
    return /*#__PURE__*/react.createElement("div", {
      className: className
    }, haystack.map((item, i) => {
      d = day + i * 7;
      return /*#__PURE__*/react.createElement("div", {
        className: "mb-1 grid grid-cols-7",
        key: d
      }, weekStack.map(() => {
        d += 1;
        isDate = d > 0 && d <= this.props.daysInMonth;
        if (isDate) {
          current = new Date(this.props.year, this.props.month, d);
          className = current.getTime() !== selectedDate.getTime() ? 'w-7 h-7 cursor-pointer text-center text-sm leading-none rounded-full text-gray-700 hover:bg-blue-50' : 'w-7 h-7 cursor-pointer text-center text-sm leading-none rounded-full bg-blue-500 text-white';
          return /*#__PURE__*/react.createElement("div", {
            className: "px-1",
            key: current.toString()
          }, /*#__PURE__*/react.createElement("button", {
            type: "button",
            className: className,
            onClick: this.handleOnSelect.bind(this, d)
          }, d));
        }
        return /*#__PURE__*/react.createElement("div", {
          key: d
        });
      }));
    }));
  }
}
DaySelect.defaultProps = {
  selectedDate: null
};
/* harmony default export */ const calendar_DaySelect = (DaySelect);
// EXTERNAL MODULE: ./react/ui/index.ts + 3 modules
var ui = __webpack_require__(35443);
// EXTERNAL MODULE: ./react/helpers/utils.ts
var utils = __webpack_require__(41906);
;// ./react/components/calendar/Header.tsx



function Header(_ref) {
  let {
    displayType,
    monthShown,
    yearShown,
    yearsIntervalShown,
    onClick,
    onPrev,
    onNext
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "mb-3 flex items-center justify-between"
  }, /*#__PURE__*/react.createElement("div", {
    role: "presentation",
    className: "text-lg font-medium text-gray-800 ".concat(displayType !== 'years' ? 'cursor-pointer hover:bg-blue-50' : 'cursor-default', " rounded p-1"),
    onClick: () => onClick()
  }, displayType === 'years' && /*#__PURE__*/react.createElement("span", null, yearsIntervalShown.from, "\u2013", yearsIntervalShown.to - 1), displayType === 'months' && /*#__PURE__*/react.createElement("span", null, yearShown), displayType === 'days' && /*#__PURE__*/react.createElement("span", null, utils/* monthNames */.dF[monthShown].slice(0, 3), " ", yearShown)), /*#__PURE__*/react.createElement("div", {
    className: "inline-flex gap-2"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    link: true,
    onClick: () => onPrev()
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "chevron-left",
    fitted: true
  })), /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    link: true,
    onClick: () => onNext()
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "chevron-right",
    fitted: true
  }))));
}
/* harmony default export */ const calendar_Header = (Header);
;// ./react/components/calendar/MonthSelect.tsx
/* provided dependency */ var MonthSelect_moment = __webpack_require__(95093);


function MonthSelect(_ref) {
  let {
    year,
    onChange,
    value
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "mb-1 grid grid-cols-4"
  }, utils/* monthNames */.dF.map((item, idx) => /*#__PURE__*/react.createElement("div", {
    key: item,
    className: "px-1"
  }, /*#__PURE__*/react.createElement("button", {
    className: idx === MonthSelect_moment(value).month() && MonthSelect_moment(value).year() === year ? 'w-full cursor-pointer rounded-full bg-blue-500 text-center text-sm leading-loose text-white' : 'w-full cursor-pointer rounded-full text-center text-sm leading-loose text-gray-700 hover:bg-blue-50',
    type: "button",
    onClick: () => onChange(idx)
  }, item.slice(0, 3)))));
}
/* harmony default export */ const calendar_MonthSelect = (MonthSelect);
;// ./react/components/calendar/RelativePickerButton.tsx

function RelativePickerButton(_ref) {
  let {
    onClick,
    label,
    highlighted,
    disabled
  } = _ref;
  const classNames = "group flex h-full w-full items-center whitespace-nowrap px-4 py-2 text-left text-sm ".concat(highlighted ? 'bg-blue-100 text-blue-600' : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900');
  return /*#__PURE__*/react.createElement("div", {
    role: "none",
    className: "h-full w-full"
  }, /*#__PURE__*/react.createElement("button", {
    onClick: onClick,
    disabled: disabled !== null && disabled !== void 0 ? disabled : false,
    type: "button",
    role: "menuitem",
    className: classNames
  }, /*#__PURE__*/react.createElement("div", {
    className: "contents"
  }, label)));
}
;// ./react/components/calendar/WeekDays.tsx


function WeekDays() {
  return /*#__PURE__*/react.createElement("div", {
    className: "mb-3 grid grid-cols-7"
  }, utils/* weekDays */.Mq.map(day => day.slice(0, 3)).map(item => /*#__PURE__*/react.createElement("div", {
    className: "px-1 text-center text-xs font-medium text-gray-800",
    key: item
  }, item)));
}
/* harmony default export */ const calendar_WeekDays = (WeekDays);
;// ./react/components/calendar/YearSelect.tsx
/* provided dependency */ var YearSelect_moment = __webpack_require__(95093);

function YearSelect(_ref) {
  let {
    yearsInterval,
    onChange,
    value
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "mb-1 grid grid-cols-4"
  }, [...Array(yearsInterval.to - yearsInterval.from).keys()].map(year => year + yearsInterval.from).map(item => /*#__PURE__*/react.createElement("div", {
    key: item,
    className: "px-1"
  }, /*#__PURE__*/react.createElement("button", {
    className: item === YearSelect_moment(value).year() ? 'w-full cursor-pointer rounded-full bg-blue-500 text-center text-sm leading-loose text-white' : 'w-full cursor-pointer rounded-full text-center text-sm leading-loose text-gray-700 hover:bg-blue-50',
    type: "button",
    onClick: () => onChange(item)
  }, item))));
}
/* harmony default export */ const calendar_YearSelect = (YearSelect);
;// ./react/components/calendar/Calendar.tsx
/* provided dependency */ var Calendar_moment = __webpack_require__(95093);







function Calendar(_ref) {
  let {
    open = null,
    value,
    showRelativePicker = true,
    onChange
  } = _ref;
  const date = value ? new Date(Calendar_moment(value).toDate()) : new Date();
  const selectedMonth = date.getMonth();
  const selectedYear = date.getFullYear();
  const [displayType, setDisplayType] = (0,react.useState)('days');
  const [yearShown, setYearShown] = (0,react.useState)(selectedYear);
  const [monthShown, setMonthShown] = (0,react.useState)(selectedMonth);
  const [yearsIntervalShown, setYearsIntervalShown] = (0,react.useState)({
    from: selectedYear - 5,
    to: selectedYear + 7
  });
  const [firstOfMonth, setFirstOfMonth] = (0,react.useState)(null);
  const [daysInMonth, setDaysInMonth] = (0,react.useState)(null);
  const shownRelativeValuesByType = (0,react.useMemo)(() => {
    // days: 1 month ago, 1 week ago, yesterday, today, tomorrow, 1 week later, 1 month later
    // months: 6 months ago, 3 months ago, 1 month ago, 1 month later, 3 months later, 6 months later
    // years: 5 years ago, 1 year ago, 1 year later, 5 years later

    const today = Calendar_moment();
    const days = [today.clone().subtract(1, 'month'), today.clone().subtract(1, 'week'), today.clone().subtract(1, 'day'), today.clone(), today.clone().add(1, 'day'), today.clone().add(1, 'week'), today.clone().add(1, 'month')];
    const months = [today.clone().subtract(6, 'month'), today.clone().subtract(3, 'month'), today.clone().subtract(1, 'month'), today.clone().add(1, 'month'), today.clone().add(3, 'month'), today.clone().add(6, 'month')];
    const years = [today.clone().subtract(5, 'year'), today.clone().subtract(1, 'year'), today.clone().add(1, 'year'), today.clone().add(5, 'year')];
    if (displayType === 'days') {
      return days;
    }
    if (displayType === 'months') {
      return months;
    }
    if (displayType === 'years') {
      return years;
    }
    return [];
  }, [displayType]);
  const setMonthDetail = (yearLocal, monthLocal) => {
    setFirstOfMonth(new Date(yearLocal, monthLocal, 0));
    setDaysInMonth(new Date(yearLocal, monthLocal + 1, 0).getDate());
  };
  const handleSetYearsIntervalShown = () => {
    setYearsIntervalShown({
      from: yearShown - 5,
      to: yearShown + 7
    });
  };
  const resetCalendar = () => {
    setYearShown(selectedYear);
    setMonthShown(selectedMonth);
    setDisplayType('days');
  };
  (0,react.useEffect)(() => {
    resetCalendar();
  }, []);
  (0,react.useEffect)(() => {
    setMonthDetail(yearShown, monthShown);
  }, [displayType, yearShown, monthShown]);
  (0,react.useEffect)(() => {
    if (open) {
      resetCalendar();
    }
  }, [open]);
  (0,react.useEffect)(() => {
    handleSetYearsIntervalShown();
  }, [yearShown]);
  const getRelativePickerDisplayClassName = () => {
    if (showRelativePicker === true) {
      return 'flex';
    }
    if (showRelativePicker === 'sm') {
      return 'sm:flex hidden';
    }
    if (showRelativePicker === 'md') {
      return 'md:flex hidden';
    }
    if (showRelativePicker === 'lg') {
      return 'lg:flex hidden';
    }
    if (showRelativePicker === 'xl') {
      return 'xl:flex hidden';
    }
    return 'hidden';
  };
  const getPrev = () => {
    if (displayType === 'days') {
      let monthLocal;
      let yearLocal;
      if (monthShown > 0) {
        monthLocal = monthShown - 1;
        yearLocal = yearShown;
      } else {
        monthLocal = 11;
        yearLocal = yearShown - 1;
      }
      setMonthDetail(yearLocal, monthLocal);
      setMonthShown(monthLocal);
      setYearShown(yearLocal);
    } else if (displayType === 'months') {
      setYearShown(old => old - 1);
    } else if (displayType === 'years') {
      setYearsIntervalShown(old => ({
        from: old.from - 12,
        to: old.from
      }));
    }
  };
  const getNext = () => {
    if (displayType === 'days') {
      let monthLocal;
      let yearLocal;
      if (monthShown < 11) {
        monthLocal = monthShown + 1;
        yearLocal = yearShown;
      } else {
        monthLocal = 0;
        yearLocal = yearShown + 1;
      }
      setMonthDetail(yearLocal, monthLocal);
      setMonthShown(monthLocal);
      setYearShown(yearLocal);
    } else if (displayType === 'months') {
      setYearShown(old => old + 1);
    } else if (displayType === 'years') {
      setYearsIntervalShown(old => ({
        from: old.to,
        to: old.to + 12
      }));
    }
  };
  const selectDate = (year, month, day) => {
    if (onChange) {
      onChange(Calendar_moment.utc([year, month, day]).toISOString());
    }
  };
  const handleYearSelect = year => {
    setYearShown(year);
    setDisplayType('months');
  };
  const handleMonthSelect = month => {
    setMonthShown(month);
    setDisplayType('days');
  };
  const handleHeaderClick = () => {
    if (displayType === 'days') {
      setDisplayType('months');
    } else if (displayType === 'months') {
      setDisplayType('years');
    }
  };
  const handleSelectRelativeValue = val => {
    onChange(val.toISOString());
    if (displayType === 'years') {
      setDisplayType('months');
    }
    if (displayType === 'months') {
      setDisplayType('days');
    }
    setMonthShown(val.month());
    setYearShown(val.year());
  };
  const formatRelativeValue = val => val.calendar(Calendar_moment(), {
    sameDay: "[".concat(gettext('Today'), "]"),
    nextDay: "[".concat(gettext('Tomorrow'), "]"),
    lastDay: "[".concat(gettext('Yesterday'), "]"),
    lastWeek: "[".concat(gettext('Last'), " ").concat(gettext('dddd'), "]"),
    nextWeek: "[".concat(gettext('Next'), " ").concat(gettext('dddd'), "]"),
    sameElse: () => "[".concat(val.fromNow(), "]")
  });
  if (firstOfMonth === null || daysInMonth === null) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: "sm:flex hidden flex-row align-middle h-full items-stretch gap-2 select-none"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex-1 sm:p-2 lg:p-4 ".concat(showRelativePicker ? 'min-w-56' : 'min-w-36')
  }, /*#__PURE__*/react.createElement(calendar_Header, {
    displayType: displayType,
    monthShown: monthShown,
    yearShown: yearShown,
    yearsIntervalShown: yearsIntervalShown,
    onClick: handleHeaderClick,
    onPrev: getPrev,
    onNext: getNext
  }), displayType === 'years' && /*#__PURE__*/react.createElement(calendar_YearSelect, {
    yearsInterval: yearsIntervalShown,
    onChange: handleYearSelect,
    value: value
  }), displayType === 'months' && /*#__PURE__*/react.createElement(calendar_MonthSelect, {
    value: value,
    onChange: handleMonthSelect,
    year: yearShown
  }), displayType === 'days' && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(calendar_WeekDays, null), /*#__PURE__*/react.createElement(calendar_DaySelect, {
    month: monthShown,
    year: yearShown,
    daysInMonth: daysInMonth,
    firstOfMonth: firstOfMonth,
    onChange: selectDate,
    value: value
  }))), /*#__PURE__*/react.createElement("div", {
    className: "border-l border-solid border-gray-200 divide-y divide-solid divide-gray-200 flex-col justify-between min-w-12 ".concat(getRelativePickerDisplayClassName())
  }, shownRelativeValuesByType.map(relativeValue => /*#__PURE__*/react.createElement(RelativePickerButton, {
    key: relativeValue.format('YYYY-MM-DD'),
    onClick: () => handleSelectRelativeValue(relativeValue),
    highlighted: Calendar_moment(value).isSame(relativeValue, 'day'),
    label: formatRelativeValue(relativeValue)
  }))));
}
/* harmony default export */ const calendar_Calendar = (Calendar);

/***/ }),

/***/ 1160:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41906);
/* harmony import */ var portal_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17961);



function firstSentence(text) {
  if (!text) return '';
  const match = text.match(/^[^.!?]+[.!?]?/);
  return match ? match[0].trim() : text;
}
function CustomField(_ref) {
  var _getValue;
  let {
    required = false,
    value,
    field,
    error,
    onChange = () => {},
    setIsLoading,
    label
  } = _ref;
  const placeholder = firstSentence(label);
  const getValue = () => {
    if (field.type === 'BANK_ACCOUNT') {
      var _value;
      return typeof value === 'string' ? value : (_value = value) === null || _value === void 0 ? void 0 : _value.local;
    }
    return value;
  };
  const [localValue, setLocalValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getValue());
  value = (_getValue = getValue()) !== null && _getValue !== void 0 ? _getValue : localValue;
  if (!value) value = '';
  const handleChange = newVal => {
    setLocalValue(newVal);
    onChange(newVal);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (field.type === 'CHAR' || field.type === 'BANK_ACCOUNT' || field.type === 'IBAN' || field.type === 'CZECH_BANK_ACCOUNT') && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.Form.Input, {
    required: required,
    label: label,
    placeholder: placeholder,
    name: label,
    value: value,
    error: error,
    onChange: handleChange
  }), field.type === 'URL' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.Form.Input, {
    type: "url",
    required: required,
    label: label,
    placeholder: placeholder,
    name: label,
    value: value,
    error: error,
    onChange: handleChange
  }), field.type === 'MULTILINE' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.Form.Textarea, {
    required: required,
    label: label,
    placeholder: placeholder,
    name: label,
    value: value,
    error: error,
    onChange: handleChange
  }), field.type === 'NUMERIC' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.Form.Input, {
    type: "number",
    step: "any",
    required: required,
    label: label,
    placeholder: placeholder,
    name: label,
    value: value,
    error: error,
    onChange: handleChange
  }), field.type === 'BOOL' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.Form.Checkbox, {
    required: required,
    label: label,
    placeholder: placeholder,
    name: label,
    value: value,
    error: error,
    onChange: handleChange
  }), field.type === 'DATE' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.Form.DatePicker, {
    required: required,
    label: label,
    value: value,
    error: error,
    onChange: handleChange
  }), field.type === 'SELECT' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.Form.Select, {
    required: required,
    label: label,
    placeholder: placeholder,
    value: value,
    choices: field.options.map(option => ({
      label: (0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .currentLanguage */ .aS)(option.label),
      value: option.id
    })),
    onChange: newValue => handleChange(newValue),
    error: error,
    sortOptions: false
  }), field.type === 'SELECTMULTI' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.Form.Multiselect, {
    required: required,
    label: label,
    placeholder: placeholder,
    value: value,
    choices: field.options.map(option => ({
      label: (0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .currentLanguage */ .aS)(option.label),
      value: option.id
    })),
    onChange: newValue => handleChange(newValue),
    error: error,
    sortOptions: false
  }), field.type === 'FILE' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.Form.FileUploadField, {
    onChange: handleChange,
    label: label,
    required: required,
    value: value,
    error: error,
    setIsLoading: setIsLoading
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomField);

/***/ }),

/***/ 75487:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   oy: () => (/* binding */ WithPortalUITheme),
/* harmony export */   ty: () => (/* binding */ usePortalUITheme)
/* harmony export */ });
/* unused harmony export PortalUIThemeContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41906);


const PortalUIThemeContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const usePortalUITheme = () => (0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .useContextSafe */ .qr)(PortalUIThemeContext);
function WithPortalUITheme(_ref) {
  let {
    formDesign,
    children
  } = _ref;
  const [design, setDesign] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(formDesign !== null && formDesign !== void 0 ? formDesign : window.appState.formDesign);
  const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    var _design$font_family_d;
    return {
      colors: {
        primary: {
          default: design.colors.primary,
          hover: design.colors.primary_hover
        },
        button: {
          default: design.colors.button_text
        }
      },
      button: {
        radius: design.button_radius
      },
      input: {
        radius: design.input_radius
      },
      font: {
        family: (_design$font_family_d = design.font_family_data) === null || _design$font_family_d === void 0 ? void 0 : _design$font_family_d.file
      },
      setDesign
    };
  }, [design]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    document.documentElement.style.setProperty('--colors-primary', value.colors.primary.default);
    document.documentElement.style.setProperty('--colors-primary-hover', value.colors.primary.hover);
    document.documentElement.style.setProperty('--colors-button-text', value.colors.button.default);
  }, [value]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(PortalUIThemeContext.Provider, {
    value: value
  }, children);
}


/***/ }),

/***/ 39512:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41906);
/* harmony import */ var portal_components_CustomField__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1160);
/* harmony import */ var portal_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17961);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




function ProductBlock(_ref) {
  let {
    block,
    value,
    errors,
    onChange
  } = _ref;
  if (block.product_custom_field_type) {
    var _errors$custom_fields;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_components_CustomField__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, {
      label: (0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .currentLanguage */ .aS)(block.name),
      required: block.is_required,
      field: block.product_custom_field_type,
      value: value.custom_fields[block.product_custom_field_type.id],
      error: errors === null || errors === void 0 || (_errors$custom_fields = errors.custom_fields) === null || _errors$custom_fields === void 0 ? void 0 : _errors$custom_fields[block.product_custom_field_type.id],
      onChange: newValue => {
        onChange(_objectSpread(_objectSpread({}, value), {}, {
          custom_fields: _objectSpread(_objectSpread({}, value.custom_fields), {}, {
            [block.product_custom_field_type.id]: newValue
          })
        }));
      }
    });
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_ui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A.Form.Input, {
    required: block.is_required,
    label: (0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .currentLanguage */ .aS)(block.name),
    name: block.product_field,
    value: value[block.product_field],
    error: errors === null || errors === void 0 ? void 0 : errors[block.product_field],
    onChange: newValue => {
      onChange(_objectSpread(_objectSpread({}, value), {}, {
        [block.product_field]: newValue
      }));
    }
  });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductBlock);

/***/ }),

/***/ 49469:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41906);
/* harmony import */ var portal_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17961);




function FormCardUI(_ref) {
  let {
    form,
    borderTop,
    onClick
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(borderTop && 'border-t', 'flex flex-col bg-white py-6 px-4 md:rounded-lg md:border md:p-6')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-base font-medium leading-6 text-gray-900"
  }, (0,helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .currentLanguage */ .aS)(form.strings.ticket_type_name)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mt-2 flex-grow text-sm text-gray-500"
  }, (0,helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .currentLanguage */ .aS)(form.strings.ticket_type_description)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(portal_ui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A.Button, {
    primary: true,
    onClick: onClick
  }, (0,helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .currentLanguage */ .aS)(form.strings.ticket_type_continue_button))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FormCardUI);

/***/ }),

/***/ 31453:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var portal_contexts_PortalUIThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75487);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35443);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const Button = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((_ref, ref) => {
  var _props$fluid, _props$size;
  let props = _extends({}, _ref);
  const theme = (0,portal_contexts_PortalUIThemeContext__WEBPACK_IMPORTED_MODULE_1__/* .usePortalUITheme */ .ty)();
  (_props$fluid = props.fluid) !== null && _props$fluid !== void 0 ? _props$fluid : props.fluid = !props.link;
  (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : props.size = 'large';
  const alterClassNames = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(classes => {
    if (theme.button.radius && !props.attached && !props.roundedFull) {
      classes = classes.filter(c => !c.includes('rounded'));
      if (theme.button.radius !== 'none') {
        classes.push("rounded-".concat(theme.button.radius));
      }
    }
    if (props.roundedFull) {
      classes = classes.filter(c => !c.includes('rounded'));
      switch (props.attached) {
        case 'left':
          classes.push('rounded-r-full');
          break;
        case 'right':
          classes.push('rounded-l-full');
          break;
        case 'both':
          classes.push('rounded-none');
          break;
        default:
          classes.push('rounded-full');
          break;
      }
    }
    if (props.primary && theme.colors.primary) {
      if (theme.colors.button) {
        classes = classes.filter(c => c !== 'text-white');
      }
      classes = classes.filter(c => !c.includes('bg-'));
      classes.push("bg-[var(--colors-primary)]");
      classes.push("hover:bg-[var(--colors-primary-hover)]");
      classes.push("text-[var(--colors-button-text)]");
    } else if (props.link) {
      classes = classes.filter(c => !c.includes('text-'));
      classes.push("text-[var(--colors-primary)]");
      classes.push("hover:text-[var(--colors-primary-hover)]");
    }
    return classes;
  }, [props.attached, props.link, props.primary, props.roundedFull, theme.button.radius, theme.colors.primary, theme.colors.button]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .$n, _extends({
    ref: ref
  }, props, {
    classNames: alterClassNames
  }));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Button);

/***/ }),

/***/ 28095:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35443);



function PortalCardChevron(_ref) {
  let {
    left,
    right,
    onClick
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex h-full w-full items-center justify-center text-gray-500",
    onClick: onClick,
    role: "row",
    tabIndex: 0
  }, left ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .In, {
    name: "chevron-left",
    solid: true
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .In, {
    name: "chevron-right",
    solid: true
  }));
}
function PortalCardCheckbox(_ref2) {
  let {
    value,
    onChange
  } = _ref2;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex h-full w-full items-center justify-center text-gray-500"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Checkbox */ .Sc, {
    value: value,
    onChange: onChange
  }));
}
function PortalCard(_ref3) {
  let {
    gray = false,
    leftAction,
    rightAction,
    children,
    loading,
    onClick
  } = _ref3;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('relative flex w-full max-w-full items-center border-t border-b border-gray-200 py-5', !gray && 'bg-white', loading && 'cursor-wait', !loading && (onClick ? 'cursor-pointer' : 'cursor-default')),
    onClick: () => !loading && onClick && onClick(),
    role: "row",
    tabIndex: 0
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex-shrink-0 basis-5"
  }, leftAction), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "min-w-0 flex-1"
  }, children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex-shrink-0 basis-5"
  }, rightAction), loading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute flex h-full w-full items-center justify-center bg-white/50"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Loader */ .aH, null)));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(PortalCard, {
  Chevron: PortalCardChevron,
  Checkbox: PortalCardCheckbox
}));

/***/ }),

/***/ 57868:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var portal_contexts_PortalUIThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75487);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function FontSetting(_ref) {
  let {
    children
  } = _ref;
  const theme = (0,portal_contexts_PortalUIThemeContext__WEBPACK_IMPORTED_MODULE_1__/* .usePortalUITheme */ .ty)();
  const [style, setStyle] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({});
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (theme.font.family) {
      const font = new FontFace('PortalFont', "url(".concat(theme.font.family, ")"));
      font.display = 'swap';
      font.load().then(() => {
        document.fonts.add(font);
        setStyle(old => _objectSpread(_objectSpread({}, old), {}, {
          fontFamily: "PortalFont"
        }));
      });
    }
  }, [theme.font.family]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "contents",
    style: style
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FontSetting);

/***/ }),

/***/ 15125:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ ui_Form)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./react/ui/index.ts + 3 modules
var ui = __webpack_require__(35443);
// EXTERNAL MODULE: ./react/portal/contexts/PortalUIThemeContext.tsx
var PortalUIThemeContext = __webpack_require__(75487);
// EXTERNAL MODULE: ./react/ui/form/formFields.tsx + 1 modules
var formFields = __webpack_require__(81723);
;// ./react/portal/ui/Form/Checkbox.tsx
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function FormCheckbox(props) {
  const theme = (0,PortalUIThemeContext/* usePortalUITheme */.ty)();
  const alterClassNames = (0,react.useCallback)(classes => {
    if (theme.input.radius && props.id !== 'map-input') {
      classes = classes.filter(c => !c.includes('rounded'));
      if (theme.input.radius !== 'none') {
        classes.push("rounded-".concat(theme.input.radius));
      }
    }
    return classes;
  }, [theme]);
  return /*#__PURE__*/react.createElement(formFields/* FormCheckbox */.cG, _extends({}, props, {
    classNames: alterClassNames
  }));
}
/* harmony default export */ const Checkbox = (FormCheckbox);
// EXTERNAL MODULE: ./react/components/calendar/Calendar.tsx + 6 modules
var Calendar = __webpack_require__(48972);
// EXTERNAL MODULE: ./react/portal/ui/index.tsx
var portal_ui = __webpack_require__(17961);
;// ./react/portal/ui/Form/DatePicker.tsx
/* provided dependency */ var moment = __webpack_require__(95093);
const _excluded = ["required"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function DatePicker(_ref) {
  let {
      required
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [isOpen, setIsOpen] = (0,react.useState)(false);
  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  const handleOnChange = selectedDate => {
    props.onChange(selectedDate);
    handleClose();
  };
  const handleReset = e => {
    props.onChange(null);
    handleClose();
    e.preventDefault();
    e.stopPropagation();
  };
  const renderInput = (0,react.useCallback)(_ref2 => {
    let {
      type,
      onChange,
      value
    } = _ref2;
    return /*#__PURE__*/react.createElement(portal_ui/* default */.A.Form.Input, {
      type: type,
      required: required,
      autoComplete: "off",
      icon: "calendar",
      placeholder: props.placeholder,
      error: props.error,
      value: value,
      onChange: e => onChange === null || onChange === void 0 ? void 0 : onChange(e),
      onClear: props.clearable ? handleReset : undefined,
      autoFocus: props.autoFocus
    });
  }, [required, props.placeholder, props.error, props.clearable, handleReset, props.autoFocus]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "hidden sm:block"
  }, /*#__PURE__*/react.createElement(ui/* Popup */.zD, {
    fluid: true,
    open: isOpen,
    onOpen: handleOpen,
    onClose: handleClose,
    on: "click",
    position: "bottom left",
    trigger: /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
      label: props.label
    }, renderInput({
      type: 'text',
      onChange: () => {},
      value: props.value ? moment(props.value).format('LL') : ''
    })),
    className: ""
  }, /*#__PURE__*/react.createElement("div", {
    className: "max-w-[400px] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 outline-none w-full"
  }, /*#__PURE__*/react.createElement(Calendar/* default */.A, {
    open: isOpen,
    value: props.value,
    onChange: handleOnChange,
    showRelativePicker: false
  })))), /*#__PURE__*/react.createElement("div", {
    className: "block sm:hidden"
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    label: props.label
  }, renderInput({
    type: 'date',
    onChange: e => handleOnChange(e),
    value: moment(props.value).format('YYYY-MM-DD')
  }))));
}
DatePicker.defaultProps = {
  placeholder: gettext('Select date'),
  value: null,
  autoFocus: false,
  clearable: false
};
/* harmony default export */ const Form_DatePicker = (DatePicker);
// EXTERNAL MODULE: ./react/components/form-controls/FileUploadField.tsx + 7 modules
var FileUploadField = __webpack_require__(44492);
;// ./react/portal/ui/Form/FileUploadField.tsx
function FileUploadField_extends() { FileUploadField_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FileUploadField_extends.apply(this, arguments); }



function FileUploadField_FileUploadField(_ref) {
  let props = FileUploadField_extends({}, _ref);
  const theme = (0,PortalUIThemeContext/* usePortalUITheme */.ty)();
  const alterClassNames = (0,react.useCallback)(classes => {
    if (theme.input.radius) {
      classes = classes.filter(c => !c.includes('rounded'));
      if (theme.input.radius !== 'none') {
        classes.push("rounded-".concat(theme.input.radius));
      }
    }
    return classes;
  }, [theme]);
  props.buttonClassNames = alterClassNames;
  return /*#__PURE__*/react.createElement(FileUploadField/* default */.A, props);
}
/* harmony default export */ const Form_FileUploadField = (FileUploadField_FileUploadField);
;// ./react/portal/ui/Form/Input.tsx
function Input_extends() { Input_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Input_extends.apply(this, arguments); }



function FormInput(props) {
  const theme = (0,PortalUIThemeContext/* usePortalUITheme */.ty)();
  const alterClassNames = (0,react.useCallback)(classes => {
    if (theme.input.radius && props.id !== 'map-input') {
      classes = classes.filter(c => !c.includes('rounded'));
      if (theme.input.radius !== 'none') {
        classes.push("rounded-".concat(theme.input.radius));
      }
    }
    return classes;
  }, [theme]);
  return /*#__PURE__*/react.createElement(formFields/* FormInput */.ZQ, Input_extends({}, props, {
    classNames: alterClassNames
  }));
}
/* harmony default export */ const Input = (FormInput);
;// ./react/portal/ui/Form/Multiselect.tsx
function Multiselect_extends() { Multiselect_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Multiselect_extends.apply(this, arguments); }



function FormMultiselect(props) {
  const theme = (0,PortalUIThemeContext/* usePortalUITheme */.ty)();
  const alterClassNames = (0,react.useCallback)(classes => {
    if (theme.input.radius) {
      classes = classes.filter(c => !c.includes('rounded'));
      if (theme.input.radius !== 'none') {
        classes.push("rounded-".concat(theme.input.radius));
      }
    }
    return classes;
  }, [theme]);
  return /*#__PURE__*/react.createElement(formFields/* FormMultiselect */.GC, Multiselect_extends({}, props, {
    classNames: alterClassNames,
    simple: true
  }));
}
/* harmony default export */ const Multiselect = (FormMultiselect);
;// ./react/portal/ui/Form/Radio.tsx
function Radio_extends() { Radio_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Radio_extends.apply(this, arguments); }



function FormRadio(props) {
  const theme = (0,PortalUIThemeContext/* usePortalUITheme */.ty)();
  const alterClassNames = (0,react.useCallback)(classes => {
    if (theme.colors.primary) {
      classes = classes.filter(c => !c.includes('focus:ring') && !c.includes('text-'));
      classes.push("text-[var(--colors-primary)]");
      classes.push("focus:ring-[var(--colors-primary-hover)]");
    }
    return classes;
  }, [theme]);
  return /*#__PURE__*/react.createElement(formFields/* FormRadio */.Mi, Radio_extends({}, props, {
    classNames: alterClassNames
  }));
}
/* harmony default export */ const Radio = (FormRadio);
;// ./react/portal/ui/Form/Select.tsx
function Select_extends() { Select_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Select_extends.apply(this, arguments); }



function FormSelect(props) {
  const theme = (0,PortalUIThemeContext/* usePortalUITheme */.ty)();
  const alterClassNames = (0,react.useCallback)(classes => {
    if (theme.input.radius) {
      classes = classes.filter(c => !c.includes('rounded'));
      if (theme.input.radius !== 'none') {
        classes.push("rounded-".concat(theme.input.radius));
      }
    }
    return classes;
  }, [theme]);
  return /*#__PURE__*/react.createElement(formFields/* FormSelect */.FX, Select_extends({}, props, {
    classNames: alterClassNames,
    simple: true
  }));
}
/* harmony default export */ const Select = (FormSelect);
;// ./react/portal/ui/Form/Textarea.tsx
function Textarea_extends() { Textarea_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Textarea_extends.apply(this, arguments); }



function FormTextarea(props) {
  const theme = (0,PortalUIThemeContext/* usePortalUITheme */.ty)();
  const alterClassNames = (0,react.useCallback)(classes => {
    if (theme.input.radius && props.id !== 'map-input') {
      classes = classes.filter(c => !c.includes('rounded'));
      if (theme.input.radius !== 'none') {
        classes.push("rounded-".concat(theme.input.radius));
      }
    }
    return classes;
  }, [theme]);
  return /*#__PURE__*/react.createElement(formFields/* FormTextarea */.hg, Textarea_extends({}, props, {
    classNames: alterClassNames
  }));
}
/* harmony default export */ const Textarea = (FormTextarea);
;// ./react/portal/ui/Form/index.tsx










function Form(props) {
  return /*#__PURE__*/react.createElement(ui/* Form */.lV, props);
}
/* harmony default export */ const ui_Form = (Object.assign(Form, {
  Field: ui/* Form */.lV.Field,
  Input: Input,
  Textarea: Textarea,
  Select: Select,
  Multiselect: Multiselect,
  Radio: Radio,
  DatePicker: Form_DatePicker,
  Checkbox: Checkbox,
  FileUploadField: Form_FileUploadField
}));

/***/ }),

/***/ 46378:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function PortalHeader(_ref) {
  let {
    header,
    description,
    padded = true
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: padded ? 'px-5 pb-5' : ''
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-base font-bold leading-7 text-gray-900"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, header)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mt-1 text-sm text-gray-500"
  }, typeof description === 'string' ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, description) : description));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PortalHeader);

/***/ }),

/***/ 92636:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function Page(_ref) {
  let {
    header,
    footer,
    children
  } = _ref;
  return (
    /*#__PURE__*/
    // We are using flex-col-reverse here to make sure the header is always on top
    // it's cleaner than using z-index
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "z-10 flex min-h-screen select-none flex-col-reverse"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "flex flex-1 flex-col py-5"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "flex flex-1 basis-0 flex-col"
    }, children), footer && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "mt-5 flex-shrink-0 space-y-4 px-5"
    }, footer)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "sticky top-0 w-full flex-shrink-0"
    }, header && header))
  );
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Page);

/***/ }),

/***/ 55421:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35443);
const _excluded = ["getColor"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ProgressBar(_ref) {
  let {
      getColor: oldGetColor
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const getColor = (progress, failed) => {
    if (failed) {
      return ['bg-red-600'];
    }
    if (progress === 100) {
      return ['bg-green-500'];
    }
    return ["bg-[var(--colors-primary)]"];
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .ProgressBar */ .z2, _extends({}, props, {
    getColor: getColor
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProgressBar);

/***/ }),

/***/ 61975:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47767);
/* harmony import */ var portal_components_UpdateFormProgressState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4396);
/* harmony import */ var portal_contexts_FormProgressContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16523);
/* harmony import */ var public_api_codegen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7816);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35443);
/* harmony import */ var _ProgressBar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55421);







const stateTexts = new Map();
stateTexts.set(public_api_codegen__WEBPACK_IMPORTED_MODULE_3__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.PRODUCTS, 'Order items');
stateTexts.set(public_api_codegen__WEBPACK_IMPORTED_MODULE_3__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.SHIPPING, 'Return shipping');
stateTexts.set(public_api_codegen__WEBPACK_IMPORTED_MODULE_3__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.REFUNDS, 'Refund options');
stateTexts.set(public_api_codegen__WEBPACK_IMPORTED_MODULE_3__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.CUSTOMER, 'Your details');
stateTexts.set(public_api_codegen__WEBPACK_IMPORTED_MODULE_3__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.SUMMARY, 'Summary');
function PortalProgressHeader(_ref) {
  let {
    currentName,
    substepProgress = 0,
    allowBack = true,
    collapsed
  } = _ref;
  const navigate = (0,react_router__WEBPACK_IMPORTED_MODULE_6__/* .useNavigate */ .Zp)();
  const {
    formProgress,
    progressBarValue,
    setProgressBarValue
  } = (0,portal_contexts_FormProgressContext__WEBPACK_IMPORTED_MODULE_2__/* .useFormProgress */ .NG)();
  const formProgressState = (0,portal_components_UpdateFormProgressState__WEBPACK_IMPORTED_MODULE_1__/* .useFormProgressState */ .e)();
  const progressBarContainerClasses = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => "sm:mt-1 ".concat(collapsed ? 'hidden sm:block' : ''), [collapsed]);
  const getNextName = () => {
    if (formProgressState) {
      if (formProgressState === public_api_codegen__WEBPACK_IMPORTED_MODULE_3__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.SUMMARY) {
        if (formProgress.payment_intent && formProgress.payment_intent.status !== 'succeeded') {
          return pgettext('portal_i18n', 'Payment');
        }
      } else if (formProgressState !== public_api_codegen__WEBPACK_IMPORTED_MODULE_3__/* .BackendPublicEnums */ .C.PortalFormProgressStateEnum.RESULT) {
        const nextState = formProgress.states[(formProgress.states.indexOf(formProgressState) || 0) + 1];
        const nextText = stateTexts.get(nextState);
        if (nextText) {
          return pgettext('portal_i18n', nextText);
        }
      }
    }
    return null;
  };
  const getCurrentProgress = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    const min = 30;
    const max = 100;
    if (formProgressState) {
      const step = (max - min) / (formProgress.states.length - 1);
      const stateIndex = formProgress.states.indexOf(formProgressState);
      setProgressBarValue(min + stateIndex * step + substepProgress * step);
    } else {
      setProgressBarValue(min);
    }
  }, [formProgressState, formProgress.states, substepProgress, setProgressBarValue]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    getCurrentProgress();
  }, [getCurrentProgress]);
  const nextName = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(getNextName, [formProgressState, formProgress.states, formProgress.payment_intent]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "w-full border-b border-gray-200 bg-white px-5 pb-3 shadow-md sm:py-6"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "text-sm font-medium leading-6 text-gray-900 sm:text-lg"
  }, currentName)), allowBack && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex cursor-pointer items-center",
    onClick: () => navigate(-1),
    tabIndex: -1,
    role: "link"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .In, {
    name: "chevron-left",
    solid: true,
    color: "gray",
    colorIntensity: 400
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "text-sm font-medium text-gray-500 hover:text-gray-600"
  }, pgettext('portal_i18n', 'Back')))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: progressBarContainerClasses
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProgressBar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A, {
    progress: progressBarValue,
    gradient: false
  })), nextName && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "hidden justify-end sm:flex"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "text-xs text-gray-500"
  }, pgettext('portal_i18n', 'Next step'), ": "), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "text-xs font-medium text-gray-500"
  }, nextName))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PortalProgressHeader);

/***/ }),

/***/ 69349:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35443);


const getBackgroundColor = color => {
  switch (color) {
    case 'red':
      return 'bg-red-50';
    case 'yellow':
      return 'bg-yellow-50';
    case 'green':
      return 'bg-green-50';
    case 'blue':
      return 'bg-blue-50';
    default:
      return 'bg-blue-50';
  }
};
const getHeadingTextColor = color => {
  switch (color) {
    case 'red':
      return 'text-red-800';
    case 'yellow':
      return 'text-yellow-800';
    case 'green':
      return 'text-green-800';
    case 'blue':
      return 'text-blue-800';
    default:
      return 'text-blue-800';
  }
};
const getTextColor = color => {
  switch (color) {
    case 'red':
      return 'text-red-700';
    case 'yellow':
      return 'text-yellow-700';
    case 'green':
      return 'text-green-700';
    case 'blue':
      return 'text-blue-700';
    default:
      return 'text-blue-700';
  }
};
const getBorderColor = color => {
  switch (color) {
    case 'red':
      return 'border-red-400';
    case 'yellow':
      return 'border-yellow-400';
    case 'green':
      return 'border-green-400';
    case 'blue':
      return 'border-blue-400';
    default:
      return 'border-blue-400';
  }
};
function Message(_ref) {
  let {
    error = false,
    warning = false,
    success = false,
    info = false,
    border = false,
    heading,
    children,
    displayIcon = true
  } = _ref;
  let color;
  let icon;
  const iconContainerClasses = ['flex-shrink-0'];
  const containerClasses = ['rounded-md', 'p-4'];
  const contentClasses = ['w-full'];
  const headingClasses = ['text-sm', 'font-medium', 'mb-2'];
  const childrenClasses = ['text-sm'];
  if (error) {
    color = 'red';
    icon = 'x-circle';
    iconContainerClasses.push('-mt-1');
  } else if (warning) {
    color = 'yellow';
    icon = 'exclamation';
    iconContainerClasses.push('-mt-0.5');
  } else if (success) {
    color = 'green';
    icon = 'check-circle';
    iconContainerClasses.push('-mt-1');
  } else {
    color = 'blue';
    icon = 'information-circle';
    iconContainerClasses.push('-mt-1');
  }
  containerClasses.push(getBackgroundColor(color));
  if (border) {
    containerClasses.push("border");
    containerClasses.push(getBorderColor(color));
  }
  headingClasses.push(getHeadingTextColor(color));
  childrenClasses.push(getTextColor(color));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: containerClasses.join(' ')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex gap-1"
  }, displayIcon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: iconContainerClasses.join(' ')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    name: icon,
    color: color,
    fitted: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: contentClasses.join(' ')
  }, heading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h3", {
    className: headingClasses.join(' ')
  }, heading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: childrenClasses.join(' ')
  }, children))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Message);

/***/ })

}]);